import React, { FC } from 'react'

const ValidationError: FC<{ message?: string }> = ({ message }) => {
  if (message) {
    return <div className="d-block invalid-feedback">{message}</div>
  }

  return null
}

export default {
  ValidationError,
}
